import { parsePhoneNumberFromString } from 'libphonenumber-js/min'

export function normalizedPhoneNumber(value, country) {
  const trimmedValue = value.trim()
  if (!trimmedValue) return ''

  const parsedNumber = parsePhoneNumberFromString(trimmedValue, country.countryCode)
  if (parsedNumber?.isValid()) return parsedNumber.number

  if (trimmedValue.startsWith('+')) return normalizedInternationalPhoneNumber(trimmedValue)

  return trimmedValue
}

function normalizedInternationalPhoneNumber(value) {
  const digits = value.replace(/\D/g, '')
  return digits ? `+${digits}` : value.trim()
}
